import Vue from 'vue'
import App from './App.vue'
import router from "./router/index.js" //引入你新建的router文件

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

//引入公共方法js文件
import publicFun from './util/public'
//调用公共方法js文件
Vue.use(publicFun);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

Vue.config.productionTip = false

let localLang = localStorage.getItem('lang');
let lang = localLang ? localLang : "en"; //实际语言包

const i18n = new VueI18n({
  locale: lang,
  silentFallbackWarn: true,
  messages: {
    en: {
        ...enLocale,
        ...require("./lang/en.json")
    },
    zh: {
        ...zhLocale,
        ...require("./lang/zh.json")
    }
  }
});
Vue.use(ElementUI, {i18n: (key, value) => i18n.t(key, value)});

new Vue({
	router,
	i18n,
  render: h => h(App),
}).$mount('#app')
